import { useRef, useState } from "react";
import { Upload, CheckCircle2, Trash2, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api, formatApiError } from "../lib/api";

export const UploadTile = ({ docType, label, hint, existingDocs = [], onChange, accept }) => {
  const inputRef = useRef(null);
  const [busy, setBusy] = useState(false);
  const docs = existingDocs.filter((d) => d.doc_type === docType);

  const upload = async (file) => {
    if (!file) return;
    setBusy(true);
    try {
      const fd = new FormData();
      fd.append("doc_type", docType);
      fd.append("file", file);
      await api.post("/documents/upload", fd);
      toast.success(`${label} uploaded`);
      onChange && onChange();
    } catch (e) {
      toast.error(formatApiError(e));
    } finally {
      setBusy(false);
      if (inputRef.current) inputRef.current.value = "";
    }
  };

  const remove = async (id) => {
    try {
      await api.delete(`/documents/${id}`);
      onChange && onChange();
    } catch (e) {
      toast.error(formatApiError(e));
    }
  };

  return (
    <div className="ditch-card p-5" data-testid={`upload-tile-${docType}`}>
      <div className="flex items-start justify-between gap-3">
        <div>
          <p className="font-heading font-bold text-[#0d2f4d] flex items-center gap-2">
            {label}
            {docs.length > 0 && <CheckCircle2 size={16} className="text-emerald-600" />}
          </p>
          {hint && <p className="text-xs text-[#51637a] mt-1">{hint}</p>}
        </div>
        <button
          onClick={() => inputRef.current?.click()}
          disabled={busy}
          data-testid={`upload-button-${docType}`}
          className="flex items-center gap-2 rounded-full border border-[#0d2f4d] text-[#0d2f4d] text-xs font-medium px-4 py-2 hover:bg-[#0d2f4d] hover:text-white transition-colors disabled:opacity-50">
          {busy ? <Loader2 size={14} className="animate-spin" /> : <Upload size={14} />}
          {docs.length > 0 ? "Replace / add" : "Upload"}
        </button>
        <input ref={inputRef} type="file" accept={accept} className="hidden"
          onChange={(e) => upload(e.target.files?.[0])} data-testid={`upload-input-${docType}`} />
      </div>
      {docs.length > 0 && (
        <ul className="mt-3 space-y-1.5">
          {docs.map((d) => (
            <li key={d.id} className="flex items-center justify-between text-xs bg-[#fcfbf8] rounded-md px-3 py-2">
              <span className="truncate text-[#122c47]">{d.filename}</span>
              <button onClick={() => remove(d.id)} className="text-[#51637a] hover:text-red-600 transition-colors ml-2"
                data-testid={`delete-doc-${d.id}`}><Trash2 size={13} /></button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};
